<div class="error-dialog-container">
  <h1 mat-dialog-title class="error-title">
    <mat-icon class="error-dialog-icon">{{ data.icon || 'lock' }}</mat-icon>
    {{ data.title }}
  </h1>
  <div mat-dialog-content class="error-content">
    <div class="error-message">
      <span class="first-sentence">{{ errorTitle }}</span>
      <span>{{ errorDescription }}</span>
    </div>
  </div>
  <div class="button-row">
    <button mat-button (click)="onReportProblem()">
      <mat-icon>bug_report</mat-icon>
      Report this problem
    </button>
    @if (data.showRequestAccess !== false) {
      <button mat-raised-button color="primary" cdkFocusInitial (click)="onRequestAccess()">Request Access</button>
      <button mat-button (click)="onTryAgain()">Retry</button>
    } @else {
      <button mat-button cdkFocusInitial (click)="onTryAgain()">Retry</button>
    }
    <button mat-button (click)="onReturnHome()">Return</button>
  </div>
</div>
